import React from 'react';
import {
  TbFileInvoice,
  TbBuildingStore,
  TbBuildingWarehouse,
  TbBuildingBank,
  TbSettings,
} from 'react-icons/tb';

const routesConfig = [
  {
    id: 'app',
    title: 'blueSoft',
    messageId: 'sidebar.blueSoft',
    type: 'group',
    idsFuncionalidad: [
      '878',
      '606',
      '607',
      '608',
      '609',
      '602',
      '701',
      '610',
      '103',
      '611',
      '801',
      '803',
      '805',
      '805',
      '807',
      '809',
      '306',
      '307',
      '308',
      '322',
      '302',
      '310',
      '702',
      '309',
      '101',
      '802',
      '804',
      '806',
      '808',
      '810',
      '825',
      '843',
      '844',
      '739',
      '742',
      '743',
      '304',
      '312',
      '605',
      '502',
      '507',
      '524',
      '401',
      '403',
    ],
    children: [
      {
        id: 'stock',
        title: 'Stock',
        messageId: 'sidebar.blueSoft.stock',
        type: 'collapse',
        icon: <TbBuildingWarehouse />,
        idsFuncionalidad: ['304', '312', '605', '502', '507', '524'],
        children: [
          {
            id: 'ingresosDeMercaderia',
            title: 'Ingresos de Mercadería',
            messageId: 'sidebar.blueSoft.stockIn',
            type: 'item',
            url: '/blueSoft/stock/ingresos',
            idsFuncionalidad: ['304', '312'],
          },
          {
            id: 'salidasDeMercaderia',
            title: 'Salidas de Mercadería',
            messageId: 'sidebar.blueSoft.stockOut',
            type: 'item',
            url: '/blueSoft/stock/salidas',
            idsFuncionalidad: ['605'],
          },
          {
            id: 'consultaStock',
            title: 'Consultas de Stock',
            messageId: 'sidebar.blueSoft.stockConsultas',
            type: 'item',
            url: '/blueSoft/stock/consulta',
            idsFuncionalidad: ['502', '507', '524'],
          },
          {
            id: 'rotacionStock',
            title: 'Rotacion de Stock',
            messageId: 'sidebar.blueSoft.stockRotation',
            type: 'item',
            url: '/blueSoft/stock/rotacion',
            idsFuncionalidad: ['502', '507', '524'],
          },
          {
            id: 'productos',
            title: 'Productos',
            messageId: 'sidebar.blueSoft.productos',
            type: 'item',
            url: '/blueSoft/stock/productos',
            idsFuncionalidad: ['102'],
          },
          {
            id: 'materiasPrimas',
            title: 'Materias Primas',
            messageId: 'sidebar.blueSoft.materiasPrimas',
            type: 'item',
            url: '/blueSoft/stock/materiasPrimas',
            idsFuncionalidad: ['167'],
          },
        ],
      },
    ],
  },
];
export default routesConfig;
